module.exports = __webpack_public_path__ + "static/V_Info_Brochure-f80b3186a4fd473bffe906626b5e0f87.png";